import type { SeedkitCore } from '@seedkit/core';
import { useSidebarUnreadBadgesStore } from 'app/src/shared/sidebar-unread-badges/sidebar-unread-badges.store';
import { refreshSidebarUnreadBadges } from 'app/src/shared/sidebar-unread-badges/refresh-sidebar-unread-badges';

export { refreshSidebarUnreadBadges };

export function bootstrapSidebarUnreadBadges(seedkit: SeedkitCore): void {
  const store = useSidebarUnreadBadgesStore();

  seedkit.eventBus.on('login', () => {
    void store.refresh();
  });

  seedkit.eventBus.on('logout', () => {
    store.clear();
  });
}
